var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import ContainerControlTemplate from '@front/templates/ContainerControlTemplate.html';
import { Control } from './Control';
export class ContainerControl extends Control {
    constructor() {
        super(...arguments);
        this.lostFocusOnOutsideClick = false;
    }
    getType() {
        return 'ContainerControl';
    }
    // Раскладываем контролы по name
    // при овверайде вызов бэйс - обязательно!
    onrender() {
        super.onrender();
        this.Controls = this.Controls || {};
        this.registerAllControl();
    }
    registerAllControl() {
        const allRactiveObject = this.findAllComponents();
        // если чтото есть, или надо перезатереть контролы которых не стало
        const len = allRactiveObject.length;
        for (let i = 0; i < len; i++) {
            const ractiveObj = allRactiveObject[i];
            if (ractiveObj.parent === this) // только своих детей
             {
                this.registerControl(ractiveObj);
            }
        }
    }
    oninit() {
        super.oninit();
        // TODO. oninit, onrender.
        this.Controls = this.Controls || {};
    }
    // управление фокусом на контейнере
    processFocus(control) {
        var _a;
        const myActiveControl = this.get('activeControl');
        if (control === myActiveControl) {
            return;
        }
        if (myActiveControl) {
            myActiveControl.lostFocus();
        }
        void this.set('activeControl', control);
        if (control) {
            if (!control.get('canSelect') && !control.get('canFocus')) {
                return;
            }
            control.gotFocus();
            const parentElement = (_a = this.get('parentContainerControl')) !== null && _a !== void 0 ? _a : this.parent;
            if (parentElement) {
                parentElement.processFocus(this);
            }
        }
        // вдруг при потере фокуса нам нужно вернуться в панель определённую( только часть АДА !!! ахахахахахаха)
        if (myActiveControl) {
            if (myActiveControl.AfterLostFocusWaiting) {
                myActiveControl.AfterLostFocusWaiting.setFocus();
            }
            myActiveControl.AfterLostFocusWaiting = null;
            // console.log(myActiveControl.getType());
        }
    }
    isActiveControlClicked(event) {
        let activeControl = this.get('activeControl');
        if (!activeControl) {
            return false;
        }
        if (!activeControl.lostFocusOnOutsideClick) {
            while (activeControl instanceof ContainerControl) {
                const childControl = activeControl.get('activeControl');
                if (isNullOrUndefined(childControl)) {
                    break;
                }
                activeControl = childControl;
            }
        }
        // TODO: activeControl may be instanceof DocumentFragment in some cases
        if (activeControl instanceof Control && activeControl.el instanceof Element) {
            let controlRect;
            if (activeControl.rendered) {
                controlRect = activeControl.find('*').getBoundingClientRect();
            }
            else {
                controlRect = activeControl.el.getBoundingClientRect();
            }
            const controlX = controlRect.left;
            const controlY = controlRect.top;
            const controlWidth = controlRect.width;
            const controlHeight = controlRect.height;
            const clickX = event.original.clientX;
            const clickY = event.original.clientY;
            if (clickX >= controlX &&
                clickX <= controlX + controlWidth &&
                clickY >= controlY &&
                clickY <= controlY + controlHeight) {
                return true; // Intersection detected
            }
            else {
                return false; // No intersection
            }
        }
        else {
            return false;
        }
    }
    lostFocus() {
        super.lostFocus();
        this.processFocus(null);
    }
    resetFocus() {
        this.processFocus(null);
    }
    // динамическое добавление контролов
    addControl(control, customPlace = false) {
        if (!control)
            return;
        control.append = true;
        void control.render(this.getClientPanel(customPlace));
        this.registerControl(control);
    }
    removeControl(control, name = undefined) {
        if (!control)
            return;
        let key = name;
        if (key === undefined)
            key = control.get('name');
        if (key === '')
            key = control._guid;
        const controls = this.Controls;
        if (!controls.hasOwnProperty(key))
            return;
        delete controls[key];
        control.dispose();
    }
    removeAllControls(exceptKeyDict) {
        exceptKeyDict = exceptKeyDict || {};
        const controls = this.Controls;
        for (const key in controls) {
            if (exceptKeyDict[key]) {
                continue;
            }
            this.removeControl(controls[key], key);
        }
    }
    removeActiveControl() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set('activeControl', null);
        });
    }
    removeParentActiveControl() {
        return __awaiter(this, void 0, void 0, function* () {
            const parentElement = this.get('parentContainerControl');
            if (parentElement) {
                yield parentElement.removeActiveControl();
            }
        });
    }
    // часть контейнера куда будет добавляться контрол
    getClientPanel(customPlace) {
        return this.el;
    }
    getControl() {
        return this.find('*');
    }
    registerControl(control) {
        const name = control.get('name');
        const key = name || name === 0 ? name : control._guid;
        const controls = this.Controls;
        controls[key] = control;
        if (control instanceof Control) {
            control.set('parentContainerControl', this);
            control.on('teardown', function () {
                delete controls[key];
            });
        }
    }
    onResizeBegin() {
        const controls = this.Controls;
        for (const key in controls) {
            const control = controls[key];
            if (control.onResizeBegin) {
                control.onResizeBegin();
            }
        }
    }
    onResizeEnd() {
        const controls = this.Controls;
        for (const key in controls) {
            const control = controls[key];
            if (control.onResizeEnd) {
                control.onResizeEnd();
            }
        }
    }
    onMouseDown(event, isHeader) {
        if (Control.IsEventProcessed(event)) {
            return;
        }
        if (!this.isActiveControlClicked(event)) {
            // Reset current active control
            this.processFocus(null);
        }
        // Call base method
        super.onMouseDown(event, isHeader);
        if (isHeader) {
            if (this.get('movable') && this.get('focused')) {
                const myParams = {};
                myParams.startMoveCoordX = event.original.pageX;
                myParams.startMoveCoordY = event.original.pageY;
                myParams.startMyX = this.get('left') || 0;
                myParams.startMyY = this.get('top') || 0;
                void this.set('onProcessMove', true);
                this.movingParameters = myParams;
            }
        }
        if (event.get('resizable') && this.get('onProcessMove') === false) {
            const myResizeParams = {};
            myResizeParams.rect = this.getElementRect(event.node);
            myResizeParams.down = {
                x: this.getPageX(event.original),
                y: this.getPageY(event.original)
            };
            myResizeParams.resizer = this.getResizer(event.original, event.node);
            this.resizeParameters = myResizeParams;
            this.onProcessResize = true;
            // Inform controls about start resizing
            this.onResizeBegin();
        }
    }
    // TODO: Maybe need transfered this methods from TerceraWindowBase
    // #region
    getPageX(event) {
        return null;
    }
    getPageY(event) {
        return null;
    }
    getElementRect(element) {
        return null;
    }
    getResizer(event, node) {
        return null;
    }
    // #endregion
    dispose() {
        const controls = this.Controls;
        if (controls) {
            for (const key in controls) {
                const control = controls[key];
                if (control.dispose) {
                    control.dispose();
                }
            }
        }
        // Object to prevent null reference exceptions.
        this.Controls = {};
        void this.teardown();
    }
}
Control.extendWith(ContainerControl, {
    template: ContainerControlTemplate,
    data: function () {
        return {
            activeControl: null
        };
    }
});
